import React, {Component} from 'react'
import Message from '../../components/Message/Mesaage'
import 'bootstrap/dist/css/bootstrap.min.css'

class ComplainMessages extends Component {
    constructor(props){
        super(props)
        console.log("Cmess")
    }    

    componentDidMount() {
        setTimeout(() => {
            document.getElementById('messages').scrollBy(0,3000)
        }, 2000);
    }

    render(){
        const putMessage = (message) => {
            return (<Message message={message}/>)
        }

        return(
            <div className="container messages" id="messages">
                {this.props.messages.map(putMessage)}
            </div>
        )
    }
}

export default ComplainMessages


// WEBPACK FOOTER //
// ./src/components/ComplainMessages/ComplainMessages.js